module.exports = __webpack_public_path__ + "static/publish_737x513-eea3c3c75d2d4a0eccdd86ad41e59a31.png";